import React, { Component } from "react";

export default class Header extends Component {
  render() {
    return (
      <header>
        <h1>
          The <code>unescape()</code> room
        </h1>
      </header>
    );
  }
}
